export class FilterRealClub {
    ctrl_page: number;
    ctrl_id: number;
    ctrl_description: string;
    ctrl_realcompetition_id: number;
    constructor(){
        this.ctrl_realcompetition_id = 0;
    }
}